import { ReactNode, useEffect, useMemo } from 'react';

import { Datetime } from '@/utils';
import DynamicContent from '@/components/DynamicContent';
import { Link } from 'react-router-dom';
import { LoadingBlur } from '@/components/LoadingSpinner';
import Tippy from '@tippyjs/react';
import { TripModalViewProps } from '@/features/Trips/components/TripModal';
import { useGetActivityForTrip } from '@/api/services/activity/SearchActivity';

const ActivityView = ({ data: trip, title }: TripModalViewProps) => {
  const [{ data, loading }, { fetch: getActivity }] = useGetActivityForTrip();

  useEffect(() => {
    if (!trip?.id) return;
    getActivity(trip?.id, trip?.offset);
  }, [trip, getActivity]);

  const activity: ReactNode[] = useMemo(() => {
    return data?.map(({ createdAt, message, sourceId }) => {
      const fromNow = new Datetime(createdAt).asDayjs().utc(true).fromNow();
      const fullMessage = `${message} (${fromNow})`;
      return (
        <>
          <small className="text-primary">{fullMessage}</small>
          {sourceId && (
            <Tippy content="View Document">
              <Link
                className="text-primary text-decoration-none"
                to={`/manifests/${sourceId}`}
                target="_blank"
                style={{ verticalAlign: 'text-top' }}
              >
                <i className="sv sv-file-preview" style={{ fontWeight: 'bold' }} />
              </Link>
            </Tippy>
          )}
        </>
      );
    });
  }, [data]);

  return (
    <div className="w-100 h-100">
      {title && <DynamicContent.Title>Activity</DynamicContent.Title>}
      <LoadingBlur loading={loading} />
      {!loading && (
        <>
          {activity?.length === 0 && <p>No activity found.</p>}
          {activity?.length > 0 &&
            (activity || []).map((message: string, index: number) => (
              <div key={index} className="d-flex gap-2 my-1">
                {message}
              </div>
            ))}
        </>
      )}
    </div>
  );
};

export default ActivityView;
